import { render, staticRenderFns } from "./agent-form.vue?vue&type=template&id=6b447371&"
import script from "./agent-form.vue?vue&type=script&lang=js&"
export * from "./agent-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports